// Modelo Compañia para administrador.
export default class Role {
    name=""
    description=""
    status=true
}



// WEBPACK FOOTER //
// ./src/model/Role.js